import React, { useRef, useState } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

import styles from './Music.module.css';

const Music = ({ dbData, wantAutoPlay }) => {
  const src = `${process.env.PUBLIC_URL}/images/gallery/${dbData.alias}/${dbData.music}`;
  const playerRef = useRef();
  const [wasPlaying, setWasPlaying] = useState(false);

  // 공통 props
  const baseProps = {
    src,
    ref: playerRef,
    loop: true,
    playsInline: true,
    preload: 'metadata',
    showSkipControls: false,
    showJumpControls: false,
    customControlsSection: ['MAIN_CONTROLS', 'VOLUME'],
    customProgressBarSection: ['PROGRESS_BAR'],
    onPlay: () => setWasPlaying(true),
    onPause: () => setWasPlaying(false),
    onSeeked: () => {
      if (wasPlaying && playerRef.current?.audio?.current) {
        playerRef.current.audio.current.play().catch((err) => {
          console.error('재생 실패:', err);
        });
      }
    },
  };

  // 조건부 병합
  const audioPlayerProps = wantAutoPlay ? { ...baseProps, autoPlay: true } : baseProps;

  return (
    <div className={styles.Music} style={{ color: `rgb(${dbData.colors.deep})` }}>
      <AudioPlayer {...audioPlayerProps} />
    </div>
  );
};

export default Music;
